// Types that applys to general projects

export enum AsyncLifecycle {
  IDLE = 'idle',
  PENDING =  'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
};
